import { render, staticRenderFns } from "./Orderhistory.vue?vue&type=template&id=71aba2af&"
import script from "./Orderhistory.vue?vue&type=script&lang=js&"
export * from "./Orderhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports